<template>
  <div>
    <a
      v-for="profile in arrProfile"
      :key="profile.link"
      :href="profile.link"
    >
      <div class="link_profile">
        <div class="link_title">{{ profile.title }}</div>
        <div class="link_detail">
          <div class="link_description">{{ profile.description }}</div>
          <div class="link_cover"><img :src="profile.cover"></div>
        </div>
        <div class="link_domain">{{ profile.domain }}</div>
      </div>

    </a>
  </div>
</template>

<script>
/**
 * 模拟动态卡片广告
 */

  export default {
    name: 'LinkProfile',
    props: {
      arrProfile: { type: Array, required: true },
    },
  }
</script>

<style lang="less">

.link_profile {max-width: 100%; border: 1px solid #ededed; padding: 10px; margin-top: 10px;}
.link_profile .link_title{font-weight: bold; margin-bottom: 5px; word-wrap: break-word; word-break: break-all;}
.link_profile .link_cover{margin-bottom: 5px; margin-top:5px;}
.link_profile .link_cover img{width: 100%; height: 100%; margin-left: 0rem;}

</style>
